import React from 'react';
import { getTenant } from '../../../../Utils/storageUtils';
import { TenantType } from '../../../../Utils/types';
import {
  reversedCategoriesMapping,
  transactionCategoriesLogos,
} from '../../../../Utils/utils';
import { getImagePath } from '../../../../Utils/assetUtils';
import styles from './index.module.css';

const TransactionIcon: React.FC<{
  categoryCode: any;
  category: any;
  merchantLogoCode: any;
  transactionImageBGProp?: any;
  iconSize?: any;
}> = ({
  category,
  categoryCode,
  iconSize,
  merchantLogoCode,
  transactionImageBGProp,
}) => {
  return (
    <div className={`${styles.transactionImageBG} ${transactionImageBGProp}`}>
      <img
        src={
          getTenant() === TenantType.PB
            ? getImagePath(
                'images/categoryIcons/' +
                  transactionCategoriesLogos[
                    categoryCode
                      ? categoryCode
                      : reversedCategoriesMapping[category.toLowerCase()]
                  ] +
                  '.svg'
              )
            : 'https://logo.ignosis.ai/' + merchantLogoCode + '.jpg'
        }
        onError={(e: any) => {
          const fallbackSrc = getImagePath('images/categoryIcons/OTHERS.svg');
          if (e.target.src !== fallbackSrc) {
            e.target.src = fallbackSrc;
          }
        }}
        className={`${styles.iconSize} ${iconSize}`}
      />
    </div>
  );
};

export default TransactionIcon;
